import { render } from "./privacyIcon.svg?vue&type=template&id=07639765"
const script = {}
script.render = render

export default script